import { FC } from "react";
import { createUseStyles } from "react-jss";
import {
  EuiModal,
  EuiModalBody,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiModalFooter,
  EuiPortal,
} from "@elastic/eui";
import { camelCaseConverter } from "utils";

const useStyles = createUseStyles({
  wizard: {
    position: "relative",
    backgroundColor: "var(--card-background)",
    zIndex: 9001,
    borderRadius: "var(--box-radius)",
    border: "1px solid var(--flyout-header)",
  },
});

interface ModalProps {
  title: any;
  onClose: () => any;
  children: any;
  footer?: any;
  maxWidth?: any;
  maxHeight?: any;
  headerContent?: any;
}

const Modal: FC<ModalProps> = ({
  title = "",
  onClose,
  children,
  footer,
  maxWidth,
  maxHeight,
  headerContent = null,
}) => {
  const classes = useStyles();
  return (
    <EuiPortal data-testid={camelCaseConverter(title || "Modal")}>
      <EuiModal
        className={classes.wizard}
        maxWidth={maxWidth || 650}
        style={{ maxHeight: maxHeight || 650 }}
        onClose={onClose}>
        <EuiModalHeader
          style={{
            paddingBlock: "12px",
            borderBottom: "2px solid var(--border-color)",
            position: "relative",
            backgroundColor: "var(--flyout-header)",
          }}>
          <div>
            <EuiModalHeaderTitle style={{ fontSize: "var(--fs16)", color: "#fff" }}>
              {title}
            </EuiModalHeaderTitle>
          </div>
          {headerContent}
        </EuiModalHeader>
        <div style={{ position: "absolute", top: "4px" }}>&nbsp;</div>
        <EuiModalBody
          style={{
            minWidth: maxWidth || 650,
            // borderBottomLeftRadius: "6px",
            // borderBottomRightRadius: "6px",
          }}>
          {children}
        </EuiModalBody>
        {footer && (
          <EuiModalFooter
            style={{
              borderTop: "0.5px solid var(--border-color)",
              backgroundColor: "var(--app-background)",
              marginTop: "8px",
            }}>
            {footer}
          </EuiModalFooter>
        )}
      </EuiModal>
    </EuiPortal>
  );
};

export default Modal;
